import { render } from "./Benefits.vue?vue&type=template&id=644a2e69&scoped=true"
import script from "./Benefits.vue?vue&type=script&lang=js"
export * from "./Benefits.vue?vue&type=script&lang=js"

import "./Benefits.vue?vue&type=style&index=0&id=644a2e69&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644a2e69"]])

export default __exports__